module.exports = __webpack_public_path__ + "static/scale-model-of-splash-pad-park-(farmer's-market)-in-oakland-california-c51bef0a8493e6c4bda7e167b0f808cc.png";